import { defineQuery } from 'next-sanity'
import { imageFields, inlineCtaFields } from '../atoms'

export const careersContentCarouselBlockFields = `
  _id,
  _type,
  variant,
  decorativeShape,
  backgroundImage {
    ${imageFields}
  },
  backgroundColor,
  items[]{
    icon {
      ${imageFields}
    },
    heading,
    mainText,
    buttonLink {
      ${inlineCtaFields}
    },
    image {
      ${imageFields}
    },
    quote,
    backgroundColor
  }
`

export const CAREERS_CONTENT_CAROUSEL_BLOCK_QUERY = defineQuery(/* groq */ `
  *[_type == "careers-content-carousel-block"][0]{
    ${careersContentCarouselBlockFields}
  }
`)
